// Override window.open to ensure that all calls to window.open with a target of '_blank' are always made with the 'noopener' and 'noreferrer' attributes
// This is to hopefully prevent any reverse tabnabbing vulnerabilities that slipped through the cracks
// https://owasp.org/www-community/attacks/Reverse_Tabnabbing
const originalWindowOpen = window.open;
window.open = (...args) => {
  // Ensure "noopener" and "noreferrer" are added to the third parameter (features)
  const [url, target, features, ...rest] = args;
  let updatedFeatures = features;
  if (target === '_blank') {
    // Features is a string of comma separated values. Add 'noopener' and 'noreferrer' if they are not already present
    if (features) {
      updatedFeatures = features.includes('noopener') ? features : `${features},noopener`;
      updatedFeatures = updatedFeatures.includes('noreferrer') ? updatedFeatures : `${updatedFeatures},noreferrer`;
    } else {
      updatedFeatures = 'noopener,noreferrer';
    }
  }
  // Pass all arguments to the original window.open function
  return originalWindowOpen.call(window, url, target, updatedFeatures, ...rest);
};
